export default function PageHeader({ title, date, description = "", color = "var(--black88)" }) {
  return (
    <div
      style={{
        padding: "0px 40px 40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "16px"
      }}
    >
      <div
        style={{
          background: color,
          height: "160px",
          width: "1px",
          marginBottom: "16px"
        }}
      />

      <h1
        className="heading"
        style={{
          fontSize: "64px",
          color,
          lineHeight: "100%",
          textAlign: "center"
        }}
      >
        {title}
      </h1>

      {description && (
        <div
          style={{
            display: "flex",
            alignItems: "flex-start"
          }}
        >
          <h2
            style={{
              margin: 0,
              lineHeight: 0.25,
              color,
              opacity: 0.72,
              fontFamily : "var(--font-Source)",
              fontStyle : "italic",
            }}
          >
            {description.slice(0, 1)}
          </h2>

          <p
            className="meta"
            style={{
              margin: 0,
              fontSize: "0.9em",
              color,
              opacity: 0.5,
              fontStyle: "italic",
              wordBreak: "break-word",
              whiteSpace: "pre-wrap",
            }}
          >
            {description.slice(1)}
          </p>
        </div>
      )}

      <p
        className="meta"
        style={{
          color,
          opacity: 0.5,
          fontSize: "var(--font-size-teeny)",
          margin: 0
        }}
      >
        Last Updated {date}
      </p>
    </div>
  );
}